import * as types from './mutation-types';

export default {
  [types.SET_CITY_COLLECTION](state, payload) {
    state.cityCollection = payload;
  },
};
